import React from "react";
import NavigationBar from "../../../components/layout/ui/NavigationBar";

const Header = (props) => <NavigationBar title={props.title} func={props.functionLogic} />;
export default Header;
